<template>
  <div class="mobile-menu">
    <TheHeaderNav class="mobile-menu__nav" :items="nav" mobile />
  </div>
</template>

<script>
import TheHeaderNav from "@/components/common/header/TheHeaderNav";

export default {
  name: "MobileMenu",
  components: {
    TheHeaderNav
  },
  props: {
    nav: Array
  }
};
</script>

<style lang="scss">
.mobile-menu {
  padding: 20px 20px 80px;
  background-color: colors(palette-1);
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 1;

  &__nav {
    width: 100%;
    height: auto;
  }
}
</style>
